import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { trackMainJsExecuted } from "@faire/web/common/performance/TrackPerformanceBreakdown/trackMainJsExecuted";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { init as initWebApi } from "./initialize/web-api";
import initializeApp from "./initializeApp";
trackMainJsExecuted(); // execute this function before anything else
(function () {
  var _main = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var container, root;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          initWebApi();
          _context.next = 3;
          return initializeApp();
        case 3:
          container = document.getElementById("root");
          root = createRoot(container);
          root.render( /*#__PURE__*/React.createElement(App, null));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function main() {
    return _main.apply(this, arguments);
  }
  return main;
})()();